"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromButton = void 0;
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var isValidString = function (href) {
    return !!href && typeof href === "string";
};
var createHtmlFromButton = function (token) {
    var text = token.text, href = token.href, alignment = token.alignment;
    var attributes = isValidString(href) && (0, URL_1.isURL)(href, true) ? "href=\"".concat(href, "\" target=\"_blank\" rel=\"noopener\"") : "href=\"#\"";
    var html = "\n  <div class=\"button-widget__container project-block__block-element\">\n  <div class=\"button-widget button-widget__render ".concat(alignment === "left" ? "button-widget--left-aligned" : "", "\">\n    <a data-qwilr-component=\"button-component\" ").concat(attributes, ">\n      <div class=\"button-widget__button center\">\n        <div class=\"button-widget__button-text user-font\">\n          ").concat(text, "\n        </div>\n      </div>\n    </a>\n  </div>\n  </div>\n  ");
    return html;
};
exports.createHtmlFromButton = createHtmlFromButton;
